var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M10.5 12h.75v5.25c0 .414.336.75.75.75h1.5a.75.75 0 0 0 0-1.5h-.75v-5.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5m0-1.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
    clipRule: "evenodd"
  })));
};
export default SvgInfoCircle;